import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "../../css/subPages.css";

import Header from "./Header";
import StartToday from "./StartToday";
import Footer from "../../components/Footer";

export default function Debunking() {
  return (
    <>
      <Header pageSectionId="informationSection" />
      <Container className="subPageContainer">
        <Row className="pt-3 mb-3">
          <Col sm={12} className="text-center">
            <div className="subPageHeadingContainer">
              <h3 className="subPageHeadingText">DEBUNKING MORTGAGE MYTHS</h3>
            </div>
          </Col>
        </Row>
        <Row className="pt-3 mb-3">
        
          <Col className="mb-4">
            <ol className="listItems">
            <h5 className="subPageListItems">
              Our team can clear up mortgage misconceptions like these, ensuring
              you have all the facts during the divorce process.<br/><br/>
            </h5>
              <li className="mb-4">
                <h5 className="subPageListItems">
                  <b>It doesn’t matter when I file the divorce petition.</b>
                  <br />
                  <br />
                  Not true. Most lenders require a court-approved settlement
                  before they can close on a new mortgage loan.
                  <br />
                  <br />
                  Financial changes included in the settlement— such as child
                  support, spousal maintenance, or marital debts—directly affect
                  what you disclose on your mortgage application. Our team can
                  determine the right time to file so you’re in a better
                  position to qualify for a new home.
                </h5>
              </li>
              <li className="mb-4">
                <h5 className="subPageListItems">
                  <b>I can claim maintenance and child support as income to qualify for a new mortgage.</b>
                  <br />
                  <br />
                  Maybe. To claim spousal or child support as income, you’ll have to show proof of receiving those payments for the past 6 months, plus have an additional 36 months of future payments due to you. 
                </h5>
              </li>
              <li className="mb-4">
                <h5 className="subPageListItems">
                  <b>My ex has full title to the property, so I don’t have to make any more mortgage payments. </b>
                  <br />
                  <br />
                  Not necessarily. Just because you signed an interspousal transfer deed and gave up title doesn’t mean you’re automatically taken off the mortgage. Which means missed payments can ding your credit. Refinancing can officially take you off the mortgage. 

                </h5>
              </li>
              <li className="mb-4">
                <h5 className="subPageListItems">
                  <b>Working with my current lender will make things easier. </b>
                  <br />
                  <br />Only if they’re trained and certified in divorce lending. A CDLP® has the knowledge, tools, and resources to represent your needs and quickly fix any conflicts during the process.


                </h5>
              </li>
              
            </ol>
          </Col>
        </Row>
        <StartToday />
      </Container>
      <Footer />
    </>
  );
}
